import React from "react";
import PropTypes from "prop-types";
import ConnectedReceiptEventFooter from "../Pages/ReceiptPage/ConnectedReceiptEventFooter";

const ReceiptFooterControl = ({ controlId }) => (
    <div className="grid">
        <div className="col col--12">
            <ConnectedReceiptEventFooter controlId={controlId} />
        </div>
    </div>
);

ReceiptFooterControl.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ReceiptFooterControl;
